import React from 'react';
import { useIntl } from 'react-intl';

import { SharedFolderProps } from '../../types/SharedFolderProps';
import { Button } from '../Button/Button';
import { Folder } from '../Folder/Folder';
import { Layout } from '../Layout/Layout';
import { LoadingContent } from '../LoadingContent/LoadingContent';

interface SharedFolderInputProps {
  folder: SharedFolderProps;
  onChange?: () => void;
  isLoading?: boolean;
}

export const FolderInput = ({
  folder,
  onChange,
  isLoading,
}: SharedFolderInputProps) => {
  const intl = useIntl();
  if (isLoading) {
    return <LoadingContent isLoading />;
  }

  return (
    <Layout spacing={2}>
      <Folder {...folder} />
      <Button
        size="s"
        text={intl.formatMessage({
          id: 'FolderInput.changeLocationButton',
          defaultMessage: 'Change Location',
          description: 'Label for the button to change the folder location',
        })}
        variant="action"
        onClick={onChange}
      />
    </Layout>
  );
};
